@if (!isLoading()) {
<div class="p-2 h-full min-h-0">
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

    <div class="flex w-full h-full min-h-0 gap-4 overflow-hidden">
        <div class="z-[2] flex-[0.3] min-w-[150px] min-h-0 flex-shrink flex flex-col overflow-hidden">
            <div class="mb-2">
                <p-button
                    class="outlined-button"
                    size="small"
                    icon="pi pi-plus"
                    severity="success"
                    label="Add Reservoir"
                    outlined="true"
                    (click)="onAddReservoir()"
                ></p-button>
            </div>
            <div class="flex-1 min-h-0 overflow-auto">
                <p-listbox
                    [scrollHeight]="''"
                    [options]="reservoirData?.reservoirs"
                    [(ngModel)]="selectedReservoir"
                    optionLabel="name"
                    (onChange)="onReservoirSelect($event)"
                >
                <ng-template let-reservoir #item>
                    <div class="flex items-center w-full">
                        <div class="flex-1 truncate">
                            <span>{{ reservoir.name }}</span>
                        </div>
                        <div>
                            <i
                                class="pi pi-trash !text-red-400"
                                pTooltip="Delete Reservoir"
                                (click)="onDeleteReservoir(reservoir)"
                            ></i>
                        </div>
                    </div>
                </ng-template>
                </p-listbox>
            </div>
        </div>

        <div class="flex-[0.7] min-w-0 min-h-0 h-full overflow-hidden">
            <app-reservoir-data
                class="block h-full min-h-0"
                [reservoir]="selectedReservoirDetails$ | async"
                (reservoirUpdate)="saveReservoir($event)"
                [disabled]="reservoirData?.reservoirs?.length < 1"
                [userUnits]="userUnits"
            ></app-reservoir-data>
        </div>
    </div>
</div>
}